import { Alert, Button, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useFetcher, useLoaderData } from 'react-router-dom';
import { uploadFileFromObject } from '../../../api/common';
import { AddFileUpload } from "../../../ui";
import styles from './production-step.module.scss';
import './templateRequested.scss';


const TemplateRequested = () => {
    const { productionDetails } = useLoaderData()
    const fileUploaderRef = useRef([])
    const fetcher = useFetcher()
    const [isUploading, setIsUploading] = useState(false)

    useEffect(() => {
        setIsUploading(fetcher.json?.action === 'uploadFileQuotation')
    }, [fetcher.data])

    const handleFilesUpload = async () => {
        if (fileUploaderRef.current.length === 0) {
            alert('Please upload atleast one Final proof')
            return
        }

        setIsUploading(true)
        const promises = fileUploaderRef.current.map(({ file }) => uploadFileFromObject(file))
        try {
            const fileIds = await Promise.all(promises)
            const imageData = fileIds.map((id, index) => ({
                id,
                comment: fileUploaderRef.current[index].comment
            }))
            fetcher.submit({
                imageData,
                id: productionDetails.id,
                action: 'sendTemplate'
            }, {
                method: 'post',
                encType: 'application/json'
            })

        }
        catch (error) {
            message.error('Unable to upload files')
        }
        finally {
            setIsUploading(true)
        }
    }
    return <div className={styles.container}>
        <h3>Tasks for you</h3>
        <Alert message="Template has been requested by Leoprinting" type='info' />
        <AddFileUpload ref={fileUploaderRef} />
        <i>Supported formats : PDF ,ESP,PSD,AI,TIFF,SVG</i>
        <div className="actions">
            <Button type='primary' onClick={handleFilesUpload} loading={isUploading} ghost>Send Template</Button>
        </div>
    </div>

}

export default TemplateRequested;